import {cloud, onyx, white} from '/theme/color/on.color';
import {chestnut, codGray} from '/theme/color/secondary.color';
import {createWebEnhancedStyles} from '/util/webStyles.util';

export const styles = createWebEnhancedStyles({
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 32,
    minWidth: 85,
    borderRadius: 3,
    paddingHorizontal: 12,
  },
  primary: {
    paddingHorizontal: 24,
  },
  primaryDisabled: {
    backgroundColor: cloud,
  },
  primaryText: {
    color: white,
  },
  secondary: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: cloud,
    paddingHorizontal: 24,
  },
  secondaryText: {
    color: onyx,
  },
  secondaryTextDisabled: {
    color: cloud,
  },
  textLink: {
    minWidth: 0,
  },
  textLinkTextDisabled: {
    color: cloud,
  },
  secondaryTextLink: {
    minWidth: 0,
  },
  secondaryLinkText: {
    color: codGray,
    textDecorationLine: 'underline',
  },
  secondaryLinkTextDisabled: {
    color: cloud,
  },
  destructive: {
    backgroundColor: chestnut,
    paddingHorizontal: 24,
  },
  destructiveText: {
    color: white,
  },
  destructiveDisabled: {
    backgroundColor: cloud,
  },
});
